import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DefaultComponent } from '../theme/pages/default/default.component';
import { Routes, RouterModule } from '@angular/router';
import { LayoutModule } from '../theme/layouts/layout.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../freightconfirmation/app.sharemodule';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { RouteOptimizationComponent } from './route-optimization.component';

const routes: Routes = [{
    'path': '',
    'component': DefaultComponent,
    'children': [{
        'path': '',
        'component': RouteOptimizationComponent,
    },
    ],
},
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        LayoutModule,
        RouterModule
    ],
    declarations: [
        RouteOptimizationComponent
    ],
    exports: [
        RouteOptimizationComponent
    ]
})



export class RouteOptimizationModule { }
